import { BnDocumentDetailsComponent } from '../bn-document-details/bn-document-details.component';
import { BnTabHeaderComponent } from '../bn-tab-header/bn-tab-header.component';
import { BillingDetailsHeaderComponent } from '../billing-details-header/billing-details-header.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { BillingPolicy } from '../add-billing/add-billing.component';
import { BillingNewService } from '@services/common/billing-new.service';
import { ActivatedRoute, NavigationEnd, Params, Router , RouterModule } from '@angular/router';
import { PolicyDataService } from '@services/data-services/policy-data.service';
import { Location, ViewportScroller } from '@angular/common';
import { EventService } from '@services/event-service.service';
import{ NavigationService } from '@services/navigation.service';
import { ActionType } from '@models/widget/action-type.enum';
import { BillingAssistanceCardsComponent } from '../billing-assistance-cards/billing-assistance-cards.component';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent, BillingDetailsHeaderComponent, BnTabHeaderComponent, BnDocumentDetailsComponent, BillingAssistanceCardsComponent],
  selector: 'app-bn-documents',
  templateUrl: './bn-documents.component.html',
  styleUrls: ['./bn-documents.component.scss']
})
export class BnDocumentsComponent implements OnInit{
  isAcmic: boolean;
  billingPolicyData: BillingPolicy;
  policyNumber: string;
  policy: any;
  company: string;
  policies: any;
  activeClass: string;

  constructor(
    private acmicService: AcmicService,
    private billingNewService: BillingNewService,
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private router: Router,
    private location:Location,
    private eventService: EventService,
    private navService: NavigationService,
    private viewportScroller: ViewportScroller,
    ) { 
      this.isAcmic = this.acmicService.isACMIC();
    }
  
  onPolicySelect(val) {
    this.policyNumber = val.split(" ")[2];
    this.router.navigate(['/billing-new', this.policyNumber, 'documents']);
    this.policy = this.getPolicyOnPolicySelect(this.billingPolicyData.policyData);
    this.eventService.emitChildEvent({key: 'policy-from-documents-tab', policy: this.policy});
  }
  getPolicyOnPolicySelect(policyData) {
    const policy = policyData.find(pol => pol?.policynumber?.policyNumber === this.policyNumber)
    return policy;
  }
  getDisplayName(policyData) {
    const policy = policyData.find(pol => pol?.policynumber?.policyNumber === this.policyNumber)
    return policy?.name;
  }
  setTheBillingDataOnReload(policies) {
    const billingPolicyData: BillingPolicy = {
      title: '',
      policyNumber: this.policyNumber,
      displayName: '',
      policyData: []
    }
    if(this.policy?.policyStatus === 'ACTIVE' || this.policy?.policyStatus === 'FUTURE') {
      billingPolicyData.title =  this.billingNewService.getActiveInActivePoliciesMap(policies,false).activePolicies.length===1?'Active policy':'Active policies';
      billingPolicyData.policyData = this.billingNewService.getActiveInActivePoliciesMap(policies,false).activePolicyMap;
      
    } else {
      billingPolicyData.title = this.billingNewService.getActiveInActivePoliciesMap(policies,false).inActivePolicies.length===1?'Inactive policy':'Inactive policies';
      billingPolicyData.policyData = this.billingNewService.getActiveInActivePoliciesMap(policies,false).inActivePolicyMap;
    }
    billingPolicyData.displayName = this.getDisplayName(billingPolicyData.policyData);
    this.billingPolicyData = billingPolicyData;
  }
  getPolicyData() {
    this.policy = this.policies?.find(pol => pol?.policynumber?.policyNumber === this.policyNumber);
    this.company = this.billingNewService.getCompany([this.policy]);
    this.setTheBillingDataOnReload(this.policies);
  }
  getPolicies() {
    this.policyDataService.$policyDetails.subscribe((policyList) => {
      if(policyList) {
        this.policies = policyList;
        this.getPolicyData();
      }
    })
  }
  getPolicyNumberFromParam() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyNumber = params['policyid'];
    })
  }
  navigateBack() {
    this.location.back();
  }

  getActivePolicies(policies: any[]): any[] {
    const activePolicyMap = this.billingNewService.getActiveInActivePoliciesMap(policies, false);
    return activePolicyMap?.activePolicyMap || [];
  }

  scrollIfFragment() {
    this.activatedRoute.fragment.subscribe(fragment => {
      if (fragment) {
        setTimeout(() => {
           this.viewportScroller.scrollToAnchor(fragment);
        }, 100);
      }
    });
  }
  
  ngOnInit(): void {
    this.scrollIfFragment();
    if(history?.state?.billingPOlicyData) {
      this.billingPolicyData = history?.state?.billingPOlicyData;
      this.policyNumber = this.billingPolicyData?.policyNumber;
    } else {
      this.getPolicyNumberFromParam();
    }
    this.getPolicies();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.startsWith('/billing-new')) {
          if(event.url.endsWith('/documents')) {
            this.activeClass = 'active';
          }
          }
        }
    });
    this.navService.saveCurrentAction(ActionType.SeeLastInvoice);
  }
}

